/*
 * Ryan O'Dowd
 * 2025-05-23
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors, isDarkMode}) => {
  return {
    seeMoreText: {
      color: colors.primaryExtraLight,
      textDecorationLine: 'underline',
      textAlign: 'center',
      paddingTop: 8,
      paddingBottom: 16,
      alignSelf: 'center',
    },
    actionBadge: {
      position: 'relative',
      marginRight: 4,
      fontSize: globalScale * 10,
      alignSelf: 'center',
    },
    sectionTitle: { // @TODO: in the dialog...could probably be in commonStyles // @TODO: duplicated in other widgets...move to widgetbase?
      marginTop: globalScale * 16,
      fontSize: globalScale * 16,
      fontFamily: fonts.secondaryBold,
      color: isDarkMode ? colors.white : colors.black,
    },
    sectionWrapper: { // @TODO: in the dialog...could probably be in commonStyles // @TODO: duplicated in other widgets...move to widgetbase?
      padding: 8,
      paddingTop: 0,
    },
    srsInfoWrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      marginTop: 4,
    },
    srsInfoText: {
      marginBottom: 8,
    },
    sliderAndTextWrapper: {
      flex: 1,
      flexDirection: 'column',
      width: '100%',
      alignItems: 'flex-start',
    },
    thumbContainer: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: colors.primary,
      padding: 4,
      marginTop: -3,
      marginLeft: -3,
      borderRadius: 8,
    },
    thumbText: {
      fontSize: 14,
      color: colors.white,
      paddingHorizontal: 4,
    },
    sliderContainer: {
      flex: 1,
      width: '100%',
    },
    wrinklesWrapper: {
      display: 'flex',
      flexDirection: 'row',
      gap: 4,
      flexWrap: 'wrap',
      marginVertical: 4,
    },
    noBottomPadding: {
      paddingBottom: 0,
    },
    textAndIconWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      maxWidth: '100%',
    },
    testTubeText: {
      display: 'flex',
      flexShrink: 1,
      marginBottom: 0,
      marginLeft: 8,
    },
    testTubeIcon: {
      fontSize: globalScale * 24,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      marginHorizontal: globalScale * 8,
      borderWidth: globalScale * 1,
      borderRadius: globalScale * 17,
      padding: globalScale * 4,
      borderColor: colors.primaryExtraLight,
    },
  };
};

export default getStyles;
